export default __webpack_public_path__ + "static/media/purpes 6.677e2ce0.png";